enum DomesticPaymentTransactionStatusDetail {
  ACTIVE = 'ACTIVE',
  AGREEMENT_SUSPENDED = 'AGREEMENT_SUSPENDED',
  BSU_AGE_EXCEEDED = 'BSU_AGE_EXCEEDED',
  BSU_TOT_EXCEEDED = 'BSU_TOT_EXCEEDED',
  BSU_YEAR_EXCEEDED = 'BSU_YEAR_EXCEEDED',
  CANCELLED = 'CANCELLED',
  CID_INVALID = 'CID_INVALID',
  CRE_ACCOUNT_INVALID = 'CRE_ACCOUNT_INVALID',
  DEB_ACCOUNT_INVALID = 'DEB_ACCOUNT_INVALID',
  LACK_OF_FUNDS = 'LACK_OF_FUNDS',
  MAX_LIMIT_EXCEEDED = 'MAX_LIMIT_EXCEEDED',
  NO_AGREEMENT = 'NO_AGREEMENT',
  NO_DISPOSAL = 'NO_DISPOSAL',
  NO_FUNDS_STOPPED = 'NO_FUNDS_STOPPED',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  OTHER = 'OTHER',
  READONLY = 'READONLY',
  SCA_NEEDED = 'SCA_NEEDED',
  STOPPED_BY_USER = 'STOPPED_BY_USER',
  TECHNICAL_FAILURE_STOPPED = 'TECHNICAL_FAILURE_STOPPED',
  TX_LIMIT_EXCEEDED = 'TX_LIMIT_EXCEEDED',
}

export default DomesticPaymentTransactionStatusDetail;
